import type { Country } from './common';

/**
 * Implements: nothing yet...
 * https://hasnode.byrayray.dev/how-to-validate-bsn-pgn-and-own-in-the-netherlands-with-typescriptjavascript
 * https://developers.wiki.kennisnet.nl/index.php?title=OSO:2022/beveiliging/versleuteling_bsn
 */
export class NL implements Country {
	/** BSN, eight or nine digits since leading zeroes are often left out */
	public readonly minLength = 8;

	// No validation implemented yet. Just fixing the broken stuff in Office for now.
	// TODO: Add validation for NL
	public validate(input: string): boolean {
		this.normalize(input);

		return true;
	}

	public normalize(input: string): string {
		return input.toUpperCase();
	}

	public getDateOfBirth(): null {
		return null;
	}
}
